import type {
  CommandData,
  CommitmentCommandData,
} from '@festina/life-general-types/life'

import type { CommandDataRecord } from '../types'
import { annotationCommands } from './annotationCommands'
import { commitmentCommands } from './commitmentCommands'
import { employerAgreementCommands } from './employerAgreementCommands'
import { pretendCommands } from './pretendCommands'

export const lifeCommands: CommandDataRecord<CommandData['_type']> = {
  ...annotationCommands,
  ...employerAgreementCommands,
  ...pretendCommands,
  ...(commitmentCommands as CommandDataRecord<CommitmentCommandData['_type']>),
}
